<template>
    <div>
        <div class="container h-100">
            <div class="d-flex justify-content-center h-100 valign">
                <div class="user_card" v-if="!isForgot" style="box-shadow: none;width: 500px;">
                    <div class="d-flex justify-content-center">
                        <div class="brand_logo_container">
                            <img src="~@/assets/images/login-logo.png" class="brand_logo" alt="Logo">
                        </div>
                    </div>
                    <div class="d-flex justify-content-center form_container">
                        <form>
                            <div class="input-group mb-3" v-if="fromChangePwd" style="width: 350px;">
                                <div class="input-group-append">
                                    <span class="input-group-text" style="background-color:  green !important;"><i class="fas fa-check"></i></span>
                                </div>
                                <input type="text" name="email" :disabled="true" style="font-size: 12px;font-weight: 700;" class="form-control input_user" value="" placeholder="email" v-model="sChangePwdSuccess">
                            </div>
                            <div class="input-group mb-3" style="width: 350px;">
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="fas fa-user"></i></span>
                                </div>
                                <input type="text" name="email" class="form-control input_user" value="" placeholder="email" v-model="email">
                            </div>
                            <div class="input-group mb-2">
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                                </div>
                                <input type="password" name="" class="form-control input_pass" value="" placeholder="password" v-model="password" @keyup.enter="handleSubmit">
                            </div>
                        </form>
                    </div>
                    <div class="d-flex justify-content-center mt-3 login_container">
                        <button type="button" name="button" class="btn login_btn" v-if="logining == 0" @click="handleSubmit" style="width: 350px;">Login</button>
                        <button type="button" name="button" class="btn login_btn" v-else disabled="" style="width: 350px;"><img src="~@/assets/images/load-button.gif"></button>
                    </div>
                    <div class="mt-4">
                        <div class="d-flex justify-content-center links">
                            <a @click="showForgot()" style="color: #007bff;cursor: pointer;">Forgot your password?</a>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3 login_container">
                        <div class='g-sign-in-button' @click="handleClickSignIn" style="width: 350px;">
                          <div class=content-wrapper>
                              <div class='logo-wrapper'>
                                  <img src='https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/512px-Google_%22G%22_Logo.svg.png'>
                              </div>
                              <span class='text-container'>
                                <span v-if="!onProccess">Login menggunakan Google</span>
                                <span v-else>Harap tunggu sedang memproses...</span>
                              </span>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="user_card" v-else style="box-shadow: none;width: 500px;">
                    <div class="d-flex justify-content-center">
                        <div class="brand_logo_container">
                            <img src="~@/assets/images/asani-logo-mini.png" class="brand_logo" alt="Logo">
                        </div>
                    </div>
                    <div class="d-flex justify-content-center form_container">
                        <form>
                            <div class="input-group mb-3" style="width: 350px;">
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="fas fa-user"></i></span>
                                </div>
                                <input type="text" name="email" class="form-control input_user" value="" placeholder="Your Email" v-model="email" @keyup.enter="submitForgot">
                            </div>
                        </form>
                    </div>
                    <div class="d-flex justify-content-center mt-3 login_container">
                        <button type="button" name="button" class="btn login_btn" v-if="logining == 0" @click="submitForgot" style="width: 350px;">Send Password Request</button>
                        <button type="button" name="button" class="btn login_btn" v-else disabled="" style="width: 350px;"><img src="~@/assets/images/load-button.gif"></button>
                    </div>
                    <div class="mt-4">
                        <div class="d-flex justify-content-center links">
                            <a @click="showForgot()" style="color: #007bff;cursor: pointer;">Back To Login Page</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import swal from "sweetalert";
    import {alert} from '../utils'

    export default {
        name: "Home",
        data() {
            return {
                spaceRegex: /[\u00A0\uFEFF\u202F]/g,
                email: "",
                password: "",
                isForgot: false,
                fromChangePwd: false,
                sChangePwdSuccess: "Success Change Password.",
                logining: 0,
                isInit: false,
                isSignIn: false,
                onProccess: false,
            };
        },
        methods: {
            handleClickGetAuth() {
                this.$gAuth
                    .getAuthCode()
                    .then((authCode) => {
                        // On success
                        return this.$http.post("http://your-backend-server.com/auth/google", { code: authCode, redirect_uri: "postmessage" });
                    })
                    .then((response) => {
                        // And then
                    })
                    .catch((error) => {
                        // On fail do something
                    });
            },

            handleClickSignIn() {
                this.onProccess = true;
                this.logining = 1;
                this.$gAuth
                    .signIn()
                    .then((user) => {
                        this.$http
                            .post(process.env.LOGIN_GOOGLE, {
                                token: user.getAuthResponse().id_token,
                            })
                            .then((response) => {
                                if (response.data.status === 200) {
                                    localStorage.setItem("admin_name", response.data.content.fullName);
                                    localStorage.setItem("jwt", response.data.content.token);
                                    localStorage.setItem("roles", JSON.stringify(response.data.content.permissions));
                                    localStorage.setItem("user_email", response.data.content.userEmail);
                                    localStorage.setItem("admin_id", response.data.content.adminId);
                                    localStorage.setItem('changeCatalogPermission', response.data.content.changedCatalog);
                                    if (localStorage.getItem("jwt") != null) {
                                        this.$emit("loggedIn");
                                        if (this.$route.params.nextUrl != null) {
                                            this.$router.push(this.$route.params.nextUrl);
                                        } else {
                                            this.$router.push("/home");
                                        }
                                    }
                                    this.onProccess = false;
                                    this.logining = 0;
                                } else {
                                    this.logining = 0;
                                    this.onProccess = false;
                                    swal("Sorry", response.data.message, "error", {
                                        button: "Ok",
                                    });
                                }
                            })
                            .catch(error => {
                                console.error(error);
                                this.logining = 0;
                                this.onProccess = false;
                            });
                    })
                    .catch((error) => {
                        this.logining = 0;
                        this.onProccess = false;
                        console.log("fail", error);
                    });
            },

            handleClickSignOut() {
                this.$gAuth
                    .signOut()
                    .then(() => {
                        // On success do something
                        this.isSignIn = this.$gAuth.isAuthorized;
                    })
                    .catch((error) => {
                        // On fail do something
                    });
            },
            toPage(e) {
                this.$router.push(e);
            },
            showForgot() {
                this.isForgot = !this.isForgot;
            },
            validateEmail(email) {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            submitForgot(e) {
                this.logining = 1;
                e.preventDefault();
                if (!this.validateEmail(this.email)) {
                    swal("Sorry", "Please check your email format", "error", {
                        button: "Ok",
                    });
                    this.logining = 0;
                } else if (this.email.length > 0) {
                    this.$http
                        .post(process.env.FORGOT_PASSWORD, {
                            email: this.email.replace(this.spaceRegex, ' '),
                        })
                        .then((response) => {
                            this.logining = 0;
                            if (response.data.status === 200) {
                                this.email = "";
                                this.isForgot = false;
                                swal("Success", "Please check your inbox/spam folder", "success", {
                                    button: "Ok",
                                });
                            } else {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                });
                            }
                        })
                        .catch(error => {
                            console.error(error.response);
                            swal("Error", error.message, "error");
                        });
                } else {
                    swal("Sorry", "Field must be fill", "error", {
                        button: "Ok",
                    });
                    this.logining = 0;
                }
            },
            handleSubmit(e) {
                this.logining = 1;
                e.preventDefault();
                if (this.password.length > 0 && this.email.length > 0) {
                    this.$http
                        .post(process.env.LOGIN, {
                            email: this.email,
                            password: this.password,
                        })
                        .then((response) => {
                            if (response.data.status === 200) {
                                localStorage.setItem("admin_name", response.data.content.fullName);
                                localStorage.setItem("jwt", response.data.content.token);
                                localStorage.setItem("roles", JSON.stringify(response.data.content.permissions));
                                localStorage.setItem("user_email", response.data.content.userEmail);
                                localStorage.setItem("admin_id", response.data.content.adminId);
                                localStorage.setItem('changeCatalogPermission', response.data.content.changedCatalog)
                                localStorage.setItem('enableSNWrongAllWarehouse', response.data.content.enableSNWrongAllWarehouse)
                                localStorage.setItem('reProcessLease', response.data.content.reProcessLease)
                                if (localStorage.getItem("jwt") != null) {
                                    this.$emit("loggedIn");
                                    if (this.$route.params.nextUrl != null) {
                                        this.$router.push(this.$route.params.nextUrl);
                                    } else {
                                        this.$router.push("/home");
                                    }
                                }
                            } else {
                                this.logining = 0;
                                alert({
                                    confirmButtonColor: "blue"
                                }).fire({
                                    title: response.data.status == 401 ? 'Akun Anda saat ini nonaktif': 'Login Gagal',
                                    html: `<p style="color: #F06400">${response.data.status == 401 ? "Silakan hubungi tim terkait untuk mengaktifkannya kembali." : response.data.message}</p>`,
                                    icon: 'error',
                                    confirmButtonText: 'Oke'
                                });
                            }
                        })
                        .catch(error => {
                            alert({
                                confirmButtonColor: "blue"
                            }).fire({
                                title: 'Login Gagal',
                                html: `<p style="color: #F06400">${error.message}</p>`,
                                icon: 'error',
                                confirmButtonText: 'Oke'
                            });
                        });
                } else {
                    alert({
                        confirmButtonColor: "blue"
                    }).fire({
                        title: "Login Gagal",
                        html: `<p style="color: #F06400">Semua input wajib diisi</p>`,
                        icon: 'error',
                        confirmButtonText: 'Oke'
                    });
                    this.logining = 0;
                }
            },
            cekLogin() {
                if (localStorage.getItem("jwt") != null) {
                    this.$router.push("/home");
                }else{
                  localStorage.clear()
                }
            },
        },
        created() {
            this.cekLogin();
            $(".modal").modal("hide");
            this.fromChangePwd = this.$route.query.changePwd;
            // this.fromChangePwd = true
        },
        mounted() {
            let that = this;
            let checkGauthLoad = setInterval(function () {
                that.isInit = that.$gAuth.isInit;
                that.isSignIn = that.$gAuth.isAuthorized;
                if (that.isInit) clearInterval(checkGauthLoad);
            }, 1000);
        },
    };
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    /* Coded with love by Mutiullah Samim */
    body,
    html {
      margin: 0;
      padding: 0;
      height: 100%;
      background: #60a3bc !important;
    }
    .user_card {
      height: 400px;
      width: 350px;
      margin-top: auto;
      margin-bottom: auto;
      background: #F8F9FA;
      position: relative;
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding: 10px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      border-radius: 5px;

    }

    .brand_logo_container_top {
      margin-top: 110px;
      margin-right: 50px;
    }

    .brand_logo_container {
      position: absolute;
      height: 170px;
      width: 170px;
      top: -75px;
      border-radius: 50%;
      background: #fff;
      padding: 10px;
      text-align: center;
    }
    .brand_logo {
      height: 150px;
      width: 150px;
      border-radius: 50%;
      border: 2px solid white;
    }
    .form_container {
      margin-top: 100px;
    }
    .login_btn {
      width: 100%;
      background: #2797FB !important;
      color: white !important;
    }
    .login_btn:focus {
      box-shadow: none !important;
      outline: 0px !important;
    }
    .login_container {
      padding: 0 2rem;
    }
    .input-group-text {
      background: #2797FB !important;
      color: white !important;
      border: 0 !important;
      border-radius: 0.25rem 0 0 0.25rem !important;
    }
    .input_user,
    .input_pass:focus {
      box-shadow: none !important;
      outline: 0px !important;
    }
    .custom-checkbox .custom-control-input:checked~.custom-control-label::before {
      background-color: #c0392b !important;
    }

    .valign{
      vertical-align: middle;
      margin: 150px 0px;
    }

    .brand_logo_container_top {
      margin-top: 110px;
      margin-right: 50px;
    }

    @media(max-width: 991px){
      .brand_logo_container_top {
      margin-top: 110px;
      margin-right: 50px;
      display: none;
    }
    }
    .g-sign-in-button {
            margin: 10px;
            display: inline-block;
            width: 240px;
            height: 50px;
            background-color: #4285f4;
            color: #fff;
            border-radius: 1px;
            transition: background-color .218s, border-color .218s, box-shadow .218s;
        }

        .g-sign-in-button:hover {
            cursor: pointer;
            -webkit-box-shadow: 0 0 3px 3px rgba(66, 133, 244, 0.3);
            box-shadow: 0 0 3px 3px rgba(66, 133, 244, 0.3);
        }

        .g-sign-in-button:active {
            background-color: #3367D6;
            transition: background-color 0.2s;
        }

        .g-sign-in-button .content-wrapper {
            height: 100%;
            width: 100%;
        }

        .g-sign-in-button img {
            width: 18px;
            height: 18px;
        }

        .g-sign-in-button .logo-wrapper {
            padding: 15px;
            background: #fff;
            width: 48px;
            height: 100%;
            border-radius: 1px;
            display: inline-block;
        }

        .g-sign-in-button .text-container {
            font-family: Roboto,arial,sans-serif;
            font-weight: 500;
            letter-spacing: .21px;
            font-size: 16px;
            line-height: 48px;
            vertical-align: top;
            border: none;
            display: inline-block;
            text-align: center;
            width: 280px;
        }
</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue